import React, { Component } from 'react';
import TerapiLogo from '../../images/desktop_new_logo.svg';

class PreloadRoom extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    const self = this;
    setTimeout(function() { self.props.connectRoomHandler(); }, 3000);
  }

  render() {

    const welcomeMessage = {
      padding: "15px",
    };

    const messageContainer = {
      marginTop: "100px",
    };

    const brandColumn = {
      paddingLeft: "30px",
    };

    const logo = {
      width: "250px",
    };

    const dateMessage = {
      marginTop: "10px",
      marginLeft: "10px",
      fontSize: "1.8em",
    };

    const sessionInformationTextColor = {
      color: "rgb(74, 74, 74)",
    };

    const sessionContainer = {
      backgroundColor: "#35cce6",
      marginLeft: "-20px",
      marginRight: "-20px",
      paddingTop: "15px",
      marginBottom: "20px",
      marginTop: "20px",
    };

    const remoteContainer = {
      paddingTop: "10px",
      paddingLeft: "35px",
    };

    const remoteFigure = {
      width: "70px",
      height: "70px",
      borderRadius: "50%",
      overflow: "hidden",
    };

    const remoteImage = {
      width: "70px",
      height: "auto",
    };

    const fullButton = {
      width: "100%",
      marginTop: "15px",
    };

    const videoPreview = {
      width: "240px",
      height: "240px",
      marginLeft: "15px",
      marginTop: "-110px",
      paddingTop: "15px",
    };

    const videoWarning = {
      backgroundColor: "#e80000",
      padding: "15px",
      textAlign: "center",
    };

    return (
      <div>
        <header className="static">
          <div className="container">
            <div className="row">
              <div className="col-lg-3 col-6">
                <div id="logo_home" className="img-fluid-2">
                  <img className="image-fluid" height="26" src={ TerapiLogo } />
                </div>
              </div>
            </div>
          </div>
        </header>
        <div className="content-wraper">
          <div className="container margin_60_35">
            <div className="row justify-content-center">
              <div className="col-lg-8">
                <div className="box_general_3 box_preview">
                  <div className="head_preview">
                    <h2>Preparando consulta</h2>
                  </div>
                  <p>Cargando...</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default PreloadRoom;
